
import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Form,
  Input,
  Button,
  Row,
  Col,
  Radio,
  Checkbox,
  DatePicker,
  Alert,
  Upload,
  message,
  Switch,
  Select,
} from "antd";

import { profileService, googleService, emergencyService, userService } from "@iso/services";
import userActions from "@iso/redux/user/actions";
import IntlMessages from "@iso/components/utility/intlMessages";
import PersonalWrapper from "./Personal.styles";
import moment from "moment";
import { dateHelper } from "@iso/lib/helpers/dateHelper";
import { getImageUrl } from "@iso/lib/helpers/imageUrl";
import PhoneInputFormItem from '@iso/components/uielements/PhoneInputFormItem';
import { convertPhoneInputToE164 } from '@iso/lib/helpers/phoneHelper';
import { UploadOutlined } from "@ant-design/icons";
import $ from "jquery";
import { apiEndpoint, apiEndpointFunction } from "@iso/lib/helpers/endpoint";
import { authHeader } from "@iso/lib/helpers/authHeader";
import _ from "lodash";
import userpic from '@iso/assets/images/AirAgri-user-144.png';
import UploadAvatarModal from "./UploadAvatarModal";
import Dashboard from "../Dashboard/Dashboard";
import { WorkingRight } from '@iso/constants/WorkingRight'
import DeleteModal from "./DeleteModal";
const { store } = userActions;
const { Option } = Select;
let autoComplete;

// Utility function to scroll to a form field and highlight it
const scrollAndHighlightField = (fieldId) => {
  const fieldElement = document.getElementById(fieldId);
  if (fieldElement) {
    fieldElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
    
    // Add highlight effect
    const formItem = fieldElement.closest('.ant-form-item') || 
                    fieldElement.closest('.ant-form-item-control')?.parentElement;
    
    if (formItem) {
      formItem.classList.add('field-error-highlight');
      setTimeout(() => {
        formItem.classList.remove('field-error-highlight');
      }, 2000);
    }
  }
};

function handleAddressAutoComplete(
  form,
  autoCompleteRef,
  setAddressShortName,
  setPoint
) {
  if (autoCompleteRef.current && autoCompleteRef.current.input) {
    autoComplete = new window.google.maps.places.Autocomplete(
      autoCompleteRef.current.input,
      { types: ["address"] }
    );

    autoComplete.setFields(["address_components", "formatted_address"]);
    autoComplete.addListener("place_changed", () => {
      handlePlaceSelect(form, setAddressShortName, setPoint);
    });
  } else {
    // console.error("autoCompleteRef or its input property is null or undefined.");
  }
}


async function handlePlaceSelect(form, setAddressShortName, setPoint) {
  const addressObject = autoComplete.getPlace();
  const fields = [
    {
      name: ["profile", "address"],
      value: addressObject.formatted_address,
    },
  ];
  for (var i = 0; i < addressObject.address_components.length; i++) {
    var addressType = addressObject.address_components[i].types[0];
    if (addressType === "country") {
      fields.push({
        name: "country",
        value: addressObject.address_components[i].long_name,
      });
    }
    if (addressType === "administrative_area_level_1") {
      fields.push({
        name: "state",
        value: addressObject.address_components[i].long_name,
      });
    }
  }
  form.setFields(fields);
}

const Personal = (props) => {
  
  const dispatch = useDispatch();
  const [form] = Form.useForm();
  const [sharedForm] = Form.useForm();
  const formRef = useRef(form);
  const [loading, setLoading] = useState(false);
  const [loadingSharing, setLoadingSharing] = useState(false);
  const [checkingPassword, setCheckingPassword] = useState(true);
  const [fields, setFields] = useState([]);
  const currentUser = useSelector((state) => state.user.user);
  const [privateChecked, setPrivateChecked] = useState(false);
  const [emailChecked, setEmailChecked] = useState(0);
  const [mobilePhoneChecked, setMobilePhoneChecked] = useState(0);
  const [homePhoneChecked, setHomePhoneChecked] = useState(0);
  const [addressChecked, setAddressChecked] = useState(0);
  const [profileData, setProfileData] = useState({});
  const [imageId, setImageId] = useState("");
  const autoCompleteRef = useRef(null);
  const [userMetas, setUserMetas] = useState({});
   const [workingRightImageId, setWorkingRightImageId] = useState(null);
  const [errMsg, setErrMsg] = useState("");
  const [visibleDltAvatar, setVisibleDltAvatar] = useState(false);
  const [visibleUploadAvatar, setVisibleUploadAvatar] = useState(false);
  const [workingRightData, setWorkingRightData] = useState();
  const [selectAvtarId, setSelectAvtarId] = useState();
  const [emergencyContact, setEmergencyContact] = useState([]);
  const [isAllow, setIsAllow] = useState(0);
  const [managerOptions, setManagerOptions] = useState([]);
  const user_id = props ? props.userId :'';
  const form_id =props ? props.formId :'';
  useEffect(() => {

      updateProfileData();
      updateEmergencyContact();

  }, [currentUser, user_id, form_id])

  useEffect(() => {
    // Fetch all users to populate manager dropdown
    const fetchManagers = async () => {
      try {
        const result = await userService.getAllUsers();
        if (result && result.users) {
          // Format users for dropdown, exclude current user
          const options = result.users
            .filter(user => user.id !== currentUser?.id)
            .map(user => ({
              value: user.id,
              label: user.email ? `${user.name} (${user.email})` : user.name
            }));
          setManagerOptions(options);
        }
      } catch (error) {
        console.error('Failed to fetch managers:', error);
      }
    };

    if (currentUser) {
      fetchManagers();
    }
  }, [currentUser]);

  
  const updateProfileData = () => {
    const getProfileFn =
      form_id && user_id
        ? profileService.getCheckinFormUserProfile(form_id, user_id)
        : profileService.getProfile();

   getProfileFn.then((res) => {
  if (res && res.code === "0000") {
    setProfileData(res.user);
    setUserMetas(res.user_metas);
    setIsAllow(res.user.share_with_property_owner ? 1 : 0);
  } else if (res && res.message) {
    // Shared key so this and Profile.js's identical toast collapse into one.
    message.error({ content: res.message, key: 'checkin-profile-error' });
  }

});


  };

  const updateEmergencyContact = () => {
    if (form_id && user_id) {
      emergencyService.getCheckinFormUserEmergency(form_id, user_id, "emergency_contact")
      .then((res) => {
        
        if (res && res.code === "0000") {
          setEmergencyContact(res.emergencies);
        }
      });
    }else if (currentUser) {
      emergencyService.getList(currentUser.id, "emergency_contact")
        .then((res) => {
          if (res.code === "0000") {
            setEmergencyContact(res.emergencies);
          }
        });
    }
  };
  useEffect(() => {
    if (autoCompleteRef) {
      document.addEventListener("google-script-loaded", handleAddress);
    }
  }, []);

  useEffect(() => {
    if (checkingPassword) {
      if (profileData.is_public == 0) {
        setPrivateChecked(true);
      }
      setEmailChecked(profileData.public_email);
      setMobilePhoneChecked(profileData.public_mobile_phone);
      setHomePhoneChecked(profileData.public_home_phone);
      setAddressChecked(profileData.public_address);

      setFields([
        {
          name: ["profile", "name"],
          value: profileData.name || "",
        },
        {
          name: ["profile", "phone"],
          value: profileData.mobile_phone || "",
        },
        {
          name: ["profile", "current_password"],
          value: "",
        },
        {
          name: ["profile", "password"],
          value: "",
        },
        {
          name: ["profile", "confirm_password"],
          value: "",
        },
        {
          name: ["profile", "email"],
          value: profileData.email || "",
        },
        {
          name: ["profile", "home_phone"],
          value: profileData.home_phone || "",
        },
        {
          name: ["profile", "surname"],
          value: profileData.surname || "",
        },
        {
          name: ["profile", "address"],
          value: profileData.address || "",
        },
        {
          name: ["profile", "date_of_birth"],
          value: profileData.date_of_birth
            ? moment(profileData.date_of_birth)
            : "",
        },
        {
          name: ['profile', 'working_right'],
          value: profileData?.working_right,
        },
        {
          name: ["profile", "manager_id"],
          value: profileData.manager_id || null,
        },
        {
          name: ["profile", "is_public"],
          value: profileData.is_public,
        },
        {
          name: ["profile", "public_surname_option"],
          value: profileData.public_surname_option || "",
        },
        {
          name: ['emergency_contact', 'full_name'],
          value: emergencyContact && emergencyContact.length ? emergencyContact[emergencyContact.length -1]['full_name'] : '',
        },
        {
          name: ['emergency_contact', 'email'],
          value: emergencyContact && emergencyContact.length ? emergencyContact[emergencyContact.length -1]['email'] : '',
        },
        {
          name: ['emergency_contact', 'phone_number'],
          value: emergencyContact && emergencyContact.length ? emergencyContact[emergencyContact.length -1]['phone_number'] : '',
        },
        {
          name: ["profile", "share_with_property_owner"],
          value: profileData.share_with_property_owner || "",
        },

      ]);
    }
  }, [checkingPassword, profileData,emergencyContact]);

  const handleAddress = () => {
    handleAddressAutoComplete(form, autoCompleteRef);
  };
 

  const handleWorkingRight = (value) => {
    if (value === 0) {
      setWorkingRightData("Working Visa");
    } else {
      setWorkingRightData("Citizen");
    }
  }
  const renderOptionWorkingRights = () => {
    let options = [];
    _.forEach(WorkingRight, (workingRight, index) => {
      options.push(
        <Option key={index} value={workingRight.value}>
          {workingRight.label}
        </Option>
      );
    });
    return (
      <Select allowClear size="large" className="workingRights" onChange={handleWorkingRight}>
        {options}
      </Select>
    );
  };
  const scrollToField = (fieldName) => {
    const fieldElement = document.querySelector(`[name="${fieldName}"]`);
    if (fieldElement) {
      fieldElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // Add a temporary highlight
      fieldElement.classList.add('field-error-highlight');
      setTimeout(() => {
        fieldElement.classList.remove('field-error-highlight');
      }, 2000);
    }
  };

  const handleSubmit = () => {
    setLoading(true);
    form
      .validateFields()
      .then((values) => {
        onStore(values);
      })
      .catch(({ errorFields }) => {
        setLoading(false);
        
        // Scroll to the first error field
        if (errorFields && errorFields.length > 0) {
          // Get the first error field's name
          const fieldName = errorFields[0].name;
          let fieldId = '';
          
          // Handle nested field names (like ["profile", "name"])
          if (Array.isArray(fieldName)) {
            fieldId = fieldName.join('_').replace(/\[|\]|"/g, '');
          } else {
            fieldId = fieldName;
          }
          
          // Try to find the input element by name or id
          const element = document.querySelector(`[name^="${fieldName[0]}"][name$="${fieldName[1]}"]`) || 
                         document.getElementById(fieldId);
          
          if (element) {
            // Scroll to the element
            element.scrollIntoView({ behavior: 'smooth', block: 'center' });
            
            // Add a temporary highlight to the form item
            const formItem = element.closest('.ant-form-item') || 
                            element.closest('.ant-form-item-control')?.parentElement;
            
            if (formItem) {
              formItem.classList.add('field-error-highlight');
              setTimeout(() => {
                formItem.classList.remove('field-error-highlight');
              }, 2000);
            }
          }
        }
      });
  };

  const handleSharingSubmit = () => {
    setLoadingSharing(true);
    sharedForm
      .validateFields()
      .then((values) => {
        onStoreSharing(values);
      })
      .catch((info) => {
        setLoadingSharing(false);
      });
  };

  const onStoreSharing = (values) => {
    
    const data = {
      user: {
        ...values.profile,
        share_with_property_owner :isAllow,
        public_email: emailChecked,
        public_mobile_phone: mobilePhoneChecked,
        public_home_phone: homePhoneChecked,
        public_address: addressChecked,
      },
    };

   
    profileService.updateCurrentProfile(data).then((res) => {
      if (res.code === "0000") {
        dispatch(store());
        updateProfileData();
        //props.cancelModal();

        setTimeout(() => {
          setLoadingSharing(false);
          message.success("Save Successfully!");
        }, 1000);
      } else {
        setTimeout(() => {
          setLoadingSharing(false);
          message.error("Save Fail!");
        }, 1000);
      }
    });
  };
  const onStore = async (values) => {
    try {
      let location_res = null;

      if (values.profile.address) {
        location_res = await googleService.getLatLng(values.profile.address);

        var point = {};
        var addressShortName = {};
        var addressLongName = {};
        if(!location_res || !location_res.results || location_res.results.length === 0 || !location_res.results[location_res.results.length - 1].geometry) {
          form.setFields([{
            name: ['profile', 'address'],
            errors: ['Please enter a valid address']
          }]);
          
          // Scroll to and highlight the address field
          scrollAndHighlightField('profile_address');
          
          throw new Error('Invalid address');
        }
        
        point = {
          lat: location_res.results[location_res.results.length - 1].geometry.location.lat,
          lng: location_res.results[location_res.results.length - 1].geometry.location.lng,
        };
      }

      // Handle antd-phone-input object format
      if (values.profile.phone) {
        values.profile.mobile_phone = convertPhoneInputToE164(values.profile.phone);
      }

      if(values.profile.current_password === '' && values.profile.password === '' && values.profile.confirm_password === ''){
        const data = {
          "user":{
            ...values.profile,
            avatar : imageId,
            date_of_birth: values.profile.date_of_birth ? dateHelper.dateForAPI(values.profile.date_of_birth) : '',
            image_id:imageId,
            address: location_res?.results?.[location_res.results.length - 1]?.formatted_address || '',
            point,
            working_right: workingRightData ? workingRightData : '',
            manager_id: values.profile.manager_id || null,
          },
          "emergency_contact": {
            ...values.emergency_contact,
            id: emergencyContact && emergencyContact.length ? emergencyContact[emergencyContact.length -1]['id'] : null,
            type: 'emergency_contact'
          }
        }

        profileService.updateCurrentProfile(data).then(res => {
          if (res.code === '0000') {
            // Handle success
            dispatch(store());
            setCheckingPassword(true);
            updateProfileData();
            form.resetFields();
            message.success('Save Successfully!');
          } else {
            // Handle error
            if (res.data && res.data.errors) {
              // Convert error from backend to Ant Design Form format
              const errorFields = [];
              const fieldErrors = {};
              
              Object.entries(res.data.errors).forEach(([field, messages]) => {
                const fieldName = field.startsWith('user.') ? field.replace('user.', '') : field;
                errorFields.push({
                  name: ['profile', fieldName],
                  errors: messages
                });
                fieldErrors[fieldName] = {
                  errors: messages
                };
              });
    
              // Set error fields to form
              form.setFields(errorFields);
              
              // Find and scroll to the first error field
              if (errorFields.length > 0) {
                const firstErrorField = errorFields[0].name.join('_');
                const errorElement = document.querySelector(`[id^="${firstErrorField}"]`);
                if (errorElement) {
                  errorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
              }
            } else {
              message.error(res.message || 'Save failed!');
            }
          }
        }).finally(() => {
          setLoading(false);
        });
      }else{
          const current_pwd = {"current_password":values.profile.current_password};
          var res = await profileService.checkCurrentPassword(current_pwd, currentUser.id);
          if(res.code !== '0000'){
            form.setFields([{
              name: ['profile', 'current_password'],
              errors: ['Current password is incorrect']
            }]);
            
            // Scroll to and highlight the current password field
            scrollAndHighlightField('profile_current_password');
            
            setCheckingPassword(false);
            setLoading(false);
            return false;
          } else {
            const data = {
              "user":{
                ...values.profile,
                date_of_birth: values.profile.date_of_birth ? dateHelper.dateForAPI(values.profile.date_of_birth) : '',
                image_id:imageId,
                address: location_res ? location_res.results[location_res.results.length - 1].formatted_address : '',
                point
              },
              "user_meta": values.user_meta
            }
            profileService.updateCurrentProfile(data).then(res => {
              if(res.code === '0000'){
                dispatch(store());
                //props.cancelModal();
                setCheckingPassword(true);
                updateProfileData();
                form.resetFields();
                setTimeout(() => {
                  setLoading(false);
                  message.success('Save Successfully!');
                }, 1000);
              } else {
                setTimeout(() => {
                  setLoading(false);
                  message.error('Save Fail!');
                }, 1000);
              }
            });
          }
      }
    } catch (error) {
      console.error('Error:', error);
      setLoading(false);
      // message.error('An error occurred while saving');
    }
  }
  const onChangeRadio = (e) => {
    if (e.target.value == 0) {
      setPrivateChecked(true);
    } else {
      setPrivateChecked(false);
    }
  };

  const onChangeEmail = (e) => {
    if (e.target.checked === true) {
      setEmailChecked(1);
    } else {
      setEmailChecked(0);
    }
  };

  const onChangeMobilePhone = (e) => {
    if (e.target.checked === true) {
      setMobilePhoneChecked(1);
    } else {
      setMobilePhoneChecked(0);
    }
  };

  const onChangeHomePhone = (e) => {
    if (e.target.checked === true) {
      setHomePhoneChecked(1);
    } else {
      setHomePhoneChecked(0);
    }
  };

  const onChangeAddress = (e) => {
    if (e.target.checked === true) {
      setAddressChecked(1);
    } else {
      setAddressChecked(0);
    }
  };

  const uploadProps = {
    name: "Image[file]",
    action: apiEndpoint.images,
    headers: authHeader(true),
    beforeUpload: (file, fileList) => {
      let $oldOne = $(".anticon-delete")[0];
      setTimeout(() => {
        if ($oldOne) $($oldOne).trigger("click");
      }, 100);
    },
    onChange: (response) => {
      if (response.file && response.file.status == "done") {
        setImageId(String(response.file.response.image.id));
      }
    },
    listType: "picture",
    multiple: false,
  };
  
  const showUploadAvatarModal = () => {
    setVisibleUploadAvatar(true);
  };

  const cancelUploadAvatarModal = () => {
    setVisibleUploadAvatar(false);
  };
  const handleDeleteImage = () => {
    setSelectAvtarId(profileData.images[profileData.images.length - 1].id);
    setVisibleDltAvatar(true);
  }
  const closeModal = () => {

    setVisibleDltAvatar(false);
  }
  const handleChangeAdHoch = (checked) => {
    setIsAllow(checked ? 1 : 0);
    
  };

  return (
    <>
      {/* <Row>
        <Col xs={{ span: 24 }} md={{ span: 11 }}> */}
      <PersonalWrapper className="profile-area statistic-card">
        <Form
          form={form}
          layout="vertical"
          scrollToFirstError
          fields={fields}
        >
          {errMsg && (
            <Alert
              message={errMsg}
              type="error"
              style={{ margin: "15px 15px 0 15px" }}
            />
          )}
          {form_id ? 
          <>
          <div className="form-title">
            <h3>
              {<IntlMessages id="profilePage.personalInformation.title" />}
            </h3>
          </div>
          <div className="form-body">
          <Row>
              <Col xs={{ span: 24 }} md={{ span: 24 }}>
                <Form.Item
                  name={["profile", "name"]}
                  className="inputAable"
                 label="Name"
                  rules={[
                    {
                      required: false,
                      message: "This field is required",
                      whitespace: true,
                    },
                  ]}
                >
                  <Input size="large" className="inputFieldCstm" placeholder="Input your name" />
                </Form.Item>
              </Col>
             
            </Row>
            <Row>
             
              <Col xs={{ span: 24 }} md={{ span: 24}}>
                <Form.Item
                  name={["profile", "surname"]}
              className="inputAable"
                 label='Surname'
                  rules={[
                    {
                      required: false,
                      message: "This field is required",
                      whitespace: true,
                    },
                  ]}
                >
                  <Input size="large" className="inputFieldCstm" placeholder="Input your surname" />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xs={{ span: 24 }} md={{ span: 24 }}>
                <Form.Item
                  name={["profile", "email"]}
                  className="inputAable"
                  label= "Email"
                  rules={[
                    {
                      type: 'email',
                      message: 'Please enter a valid email address',
                    },
                    {
                      required: false,
                      message: "This field is required",
                      whitespace: true,
                    },
                  ]}
                >
                  <Input size="large" className="inputFieldCstm" placeholder="Input your email" />
                </Form.Item>
              </Col>
              </Row>
            <Row>
              <Col xs={{ span: 24 }} md={{ span: 24 }}>
                <Form.Item
                  name={["profile", "manager_id"]}
                  label="Manager"
                  className="isoInputWrapper"
                >
                  <Select
                    size="large"
                    placeholder="Select your manager"
                    allowClear
                    showSearch
                    optionFilterProp="label"
                    options={managerOptions}
                  />
                </Form.Item>
              </Col>
            </Row>
          </div>
          </>
          
         :
         <>
          <div className="form-title">
            <h3>
              {<IntlMessages id="profilePage.personalInformation.title" />}
            </h3>
          </div>
          <div className="form-body">
            <div className="btnGroup">
            <Row>
              <Col xs={{ span: 12 }} md={{ span: 5 }}>
                
                  <img
                    className="profile-image"
                    style={{ width: "150px", height: "150px" }}
                    alt="Avatar"
                    src={profileData.images && profileData.images.length > 0 ?
                      getImageUrl(profileData.images[profileData.images.length - 1], userpic) :userpic
                    }
                  />
                </Col>
              {/* <Col xs={{ span: 7 }} md={{ span: 7 }}> */}
              <Form.Item
                name={["profile", "choose_image"]}
                className="inputLabelCstm"
              // label="Upload Avatar"
              >
                <Upload {...uploadProps}>
                  <Button
                    className="uploadAvatar"
                    icon={<UploadOutlined />}
                  >
                    Upload New picture
                  </Button>
                </Upload>
              </Form.Item>
              <Form.Item
                name={["profile", "choose_image"]}
                className="isoInputWrapper"
              // label="Choose an image"
              >
                <Button
                  className="DltImg"
                  // icon={<UploadOutlined />}
                  onClick={handleDeleteImage}
                >
                  Delete
                </Button>
              </Form.Item>
            </Row>
            </div>
            <br />
            <br />
            <Row>
              <Col xs={{ span: 24 }} md={{ span: 11 }}>
                <Form.Item
                  name={["profile", "name"]}
                  className="inputAable"
                  label="Name"
                  rules={[
                    {
                      required: true,
                      message: "This field is required",
                      whitespace: true,
                    },
                  ]}
                >
                  <Input size="large" className="inputFieldCstm" placeholder="Input your name" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                <Form.Item
                  name={["profile", "surname"]}
              className="inputAable"
                 label='Surname'
                  rules={[
                    {
                      required: false,
                      message: "This field is required",
                      whitespace: true,
                    },
                  ]}
                >
                  <Input size="large" className="inputFieldCstm" placeholder="Input your surname" />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xs={{ span: 24 }} md={{ span: 11 }}>
                <Form.Item
                  name={["profile", "date_of_birth"]}
                  className="inputAable"
                 label="Date of Birth"
                  rules={[
                    {
                      required: false,
                      message: "This field is required",
                    },
                  ]}
                >
                  <DatePicker size="large" className="inputFieldCstm" style={{ width: "100%", border: 'none !important' }} />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
              <Form.Item
            className="inputAable"
                  name={['profile', 'working_right']}
                  label="Working right"
                  rules={[
                    {
                      required: false,
                      message: 'This field is required',
                    },
                  ]}
                >
                  {renderOptionWorkingRights(WorkingRight)}
                </Form.Item>
              </Col>
            </Row>

            <div className="changePassword">
              <h4 className="PassInfo">
                {<IntlMessages id="Password Settings" />}
              </h4>
            </div>
            <Row>
              <Col xs={{ span: 24 }} md={{ span: 11 }}>
                <Form.Item
                  name={["profile", "current_password"]}
                  className="inputAable"
                  label="Current Password"
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        const newPassword = getFieldValue(["profile", "password"]);
                        const confirmPassword = getFieldValue(["profile", "confirm_password"]);
                        
                        // If new password or confirm password is entered, current password is required
                        if ((newPassword || confirmPassword) && !value) {
                          return Promise.reject('Please enter your current password');
                        }
                        
                        // if (value) {
                        //   // Clear new password and confirm password fields when current password changes
                        //   form.setFieldsValue({
                        //     profile: {
                        //       ...form.getFieldValue('profile') || {},
                        //       password: '',
                        //       confirm_password: ''
                        //     }
                        //   });
                        // }
                        
                        return Promise.resolve();
                      },
                    }),
                  ]}
                >
                  <Input.Password 
                    size="large" 
                    className="inputFieldCstm password-placeholder" 
                    placeholder="Input current password" 
                    id="profile_current_password"
                  />
                </Form.Item>
              </Col>
             
              <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                <Form.Item
                  name={["profile", "password"]}
                  className="inputAable"
                  label="New Password"
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        const currentPassword = getFieldValue(["profile", "current_password"]);
                        
                        if (currentPassword) {
                          if (!value) {
                            return Promise.reject('Please enter a new password');
                          }
                          if (value === currentPassword) {
                            return Promise.reject('New password must be different from current password');
                          }
                        }
                        return Promise.resolve();
                      },
                    }),
                  ]}
                >
                  <Input.Password 
                    size="large" 
                    className="inputFieldCstm password-placeholder" 
                    placeholder="Input new password" 
                    id="profile_password"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xs={{ span: 24 }} md={{ span: 11 }}></Col>
              <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                <Form.Item
                  name={["profile", "confirm_password"]}
                  className="inputAable"
                  label="Confirm New Password"
                  dependencies={['profile.password']}
                  rules={[
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        const newPassword = getFieldValue(["profile", "password"]);
                        const currentPassword = getFieldValue(["profile", "current_password"]);
                        
                        if (currentPassword) {
                          if (!value) {
                            return Promise.reject('Please confirm your new password');
                          }
                          if (value !== newPassword) {
                            return Promise.reject('Confirm password does not match new password');
                          }
                        }
                        return Promise.resolve();
                      },
                    }),
                  ]}
                >
                  <Input.Password 
                    size="large" 
                    className="inputFieldCstm password-placeholder" 
                    placeholder="Confirm new password" 
                    id="profile_confirm_password"
                  />
                </Form.Item>
              </Col>
            </Row>
            <div className="changePassword">
              <h4 className="PassInfo">
                {<IntlMessages id="Contact Information" />}
              </h4>
            </div>
            {/* <div className="form-body"> */}
            <Row>
              <Col xs={{ span: 24 }} md={{ span: 11 }}>
                <Form.Item
                  name={["profile", "email"]}
                  className="inputAable"
                  label= "Email"
                  rules={[
                    {
                      type: 'email',
                      message: 'Please enter a valid email address',
                    },
                    {
                      required: true,
                      message: "This field is required",
                      whitespace: true,
                    },
                  ]}
                >
                  <Input size="large" readOnly className="inputFieldCstm" placeholder="Input your email" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                <PhoneInputFormItem
                  name={["profile", "phone"]}
                  label="Mobile Phone"
                  placeholder="Enter your mobile phone number"
                />
              </Col>
            </Row>
            <Row>
              <Col xs={{ span: 24 }} md={{ span: 11 }}>
                <Form.Item
                  name={["profile", "home_phone"]}
                  className="inputAable"
                  label = "Home Phone"
                  rules={[
                    {
                      required: false,
                      message: "This field is required",
                      whitespace: true,
                    },
                    {
                      pattern: /^\d{10,12}$/, // Adjust this pattern as per your phone number format
                      message: 'Phone number must be 10 to 12 digits!',
                    },
                  ]}
                >
                  <Input
                   onKeyDown={(e) => {
                    // Allow only numbers (0-9) and specific control keys
                    if (!/^\d+$/.test(e.key) && !['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(e.key)) {
                      e.preventDefault();
                    }
                  }}
                    className="inputFieldCstm"
                    size="large"
                    placeholder="Input your home phone number"
                  />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                <Form.Item
                  name={["profile", "address"]}
                  className="inputAable"
                  label="Address"
                  rules={[
                    {
                      required: false,
                      message: "This field is required",
                      whitespace: true,
                    },
                  ]}
                >
                  <Input
                    className="inputFieldCstm"
                    size="large"
                    placeholder="Input your address"
                    ref={autoCompleteRef}
                  />
                </Form.Item>
                {errMsg && <Alert message={errMsg} type="error" />}
              </Col>
            </Row>
            <div className="changePassword">
              <h3 className="PassInfo">
                {<IntlMessages id="Emergency Contact" />}
              </h3>
            </div>
            <Row>
              <Col xs={{ span: 24 }} md={{ span: 11 }}>
                <Form.Item
                   name={['emergency_contact', 'full_name']}
                   className="inputAable"
                  label= 'Full Name'
                  rules={[
                    {
                      required: false,
                      message: "This field is required",
                      whitespace: true,
                    },
                  ]}
                >
                  <Input size="large" className="inputFieldCstm" placeholder="Input your full name" />
                </Form.Item>
              </Col>
              <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                <Form.Item
                  name={['emergency_contact', 'email']}
                  className="inputAable"
                  label="Email"
                  rules={[
                    {
                      type: 'email',
                      message: 'Please enter a valid email address',
                    },
                    {
                      required: false,
                      message: 'This field is required',
                      whitespace: true,
                    },
                  ]}
                >
                  <Input
                    className="inputFieldCstm"
                    size="large"
                    placeholder="Input your email"
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col xs={{ span: 24 }} md={{ span: 11 }}>
                <Form.Item
                  name={['emergency_contact', 'phone_number']}

                  className="inputAable"
                label="Phone Number"
                  rules={[
                    {
                      required: false,
                      message: "This field is required",
                      whitespace: true,
                    },
                    {
                      pattern: /^\d{10,12}$/,
                      message: 'Phone number must be 10 to 12 digits!',
                    },
                  ]}

                >
                  <Input size="large"
                    onKeyDown={(e) => {
                      if (!/^\d+$/.test(e.key) && !['Backspace', 'ArrowLeft', 'ArrowRight', 'Delete'].includes(e.key)) {
                        e.preventDefault();
                      }
                    }}
                  className="inputFieldCstm" placeholder="Input your phone number" />
                </Form.Item>
              </Col>
            </Row>
            <Row style={{ marginTop: "15px" }}>
              <Col xs={{ span: 11 }} md={{ span: 11 }}></Col>
              <Col
                xs={{ span: 11, offset: 2 }}
                md={{ span: 11, offset: 2 }}
              >
                <Button
                  key="submit"
                  className="btn-success"
                  type="primary"
                  style={{ float: "right" }}
                  onClick={handleSubmit}
                  loading={loading}
                >
                  {<IntlMessages id="propertyPage.modal.save" />}
                </Button>
              </Col>
            </Row>
           
            <div className="changePassword">
              <h4 className="PassInfo">
                {<IntlMessages id="Airagri community Settings" />}
              </h4>
            </div>
           
            <Form
              form={sharedForm}
              layout="vertical"
              scrollToFirstError
              fields={fields}
            >
              <Row>
                <Col xs={{ span: 24 }} md={{ span: 11 }}>
                  <div>
                    <h3 className="shareToCommunity">
                      {<IntlMessages id="profilePage.shareToCommunity.title" />}
                    </h3>
                  </div>
                  <Form.Item
                    name={["profile", "is_public"]}
                    className="inputLabelCstm"
                    label=""
                  >
                    <Radio.Group onChange={onChangeRadio}>
                      <Radio value={1}>Public</Radio>
                      <Radio value={0}>Private</Radio>
                    </Radio.Group>
                  </Form.Item>
                  <div>
                    <h3 className="shareToCommunity">
                      {<IntlMessages id="Surname" />}
                    </h3>
                  </div>

                  <Form.Item
                    name={["profile", "public_surname_option"]}
                    className="inputLabelCstm"
                   
                  >
                    <Radio.Group disabled={privateChecked}>
                      <Row>
                        <Radio value={1}>Share Initial</Radio>


                        <Radio value={2}>Share Surname</Radio>
                      </Row>
                    </Radio.Group>
                  </Form.Item>

                </Col>
                <Col xs={{ span: 24 }} md={{ span: 11, offset: 2 }}>
                  <div>
                    <h3 className="shareToCommunity">
                      {<IntlMessages id="Shared with property owner" />}
                    </h3>
                  </div>
                  <Form.Item
                   name={["profile", "share_with_property_owner"]}
                    className="inputLabelCstm"
                    // valuePropName="checked"
                  >
                    <Switch
                   
                  //  unCheckedChildren="Deny"
                  //  checkedChildren="Allow"
                   checked={isAllow === 1}  // Set based on isAllow value
                   onChange={(checked) => handleChangeAdHoch(checked)}
                    /> <span>{isAllow === 1 ?"Allow" : "Deny"}</span>
                  </Form.Item>
                  <div>
                    <h3 className="shareToCommunity">
                      {<IntlMessages id="Contact Information" />}
                    </h3>
                  </div>
                  <Row>
                    <Col xs={{ span: 11 }} md={{ span: 11 }}>
                      <Checkbox

                        className="checkbox-contact"
                        disabled={privateChecked}
                        onChange={onChangeEmail}
                        checked={emailChecked}
                      ></Checkbox>
                      <span className="contCheckBox">Email</span>
                    </Col>
                    <Col
                      xs={{ span: 11, offset: 2 }}
                      md={{ span: 11, offset: 2 }}
                    >
                      <Checkbox
                        className="checkbox-contact"
                        disabled={privateChecked}
                        onChange={onChangeMobilePhone}
                        checked={mobilePhoneChecked}
                      ></Checkbox><span className="contCheckBox">Mobile Phone</span>
                    </Col>
                  </Row>
                  <Row>
                    <Col xs={{ span: 11 }} md={{ span: 11 }}>
                      <Checkbox
                        className="checkbox-contact"
                        disabled={privateChecked}
                        onChange={onChangeHomePhone}
                        checked={homePhoneChecked}
                      ></Checkbox>
                      <span className="contCheckBox">Home Phone</span>

                    </Col>
                    <Col
                      xs={{ span: 11, offset: 2 }}
                      md={{ span: 11, offset: 2 }}
                    >
                      <Checkbox
                        className="checkbox-contact"
                        disabled={privateChecked}
                        onChange={onChangeAddress}
                        checked={addressChecked}
                      ></Checkbox>
                      <span className="contCheckBox">Address</span>
                    </Col>

                  </Row>

                </Col>

              </Row>
              <Row></Row>

              <div className="form-body">

                <Row style={{ marginTop: "15px" }}>
                  <Col xs={{ span: 11 }} md={{ span: 11 }}></Col>
                  <Col
                    xs={{ span: 11, offset: 2 }}
                    md={{ span: 11, offset: 2 }}
                  >
                    <Button
                      key="submit"
                      className="btn-success"
                      type="primary"
                      style={{ float: "right" }}
                      onClick={handleSharingSubmit}
                      loading={loadingSharing}
                    >
                      {<IntlMessages id="propertyPage.modal.save" />}
                    </Button>
                  </Col>
                </Row>
              </div>
            </Form>
</div>
          </>}
            {/* </div> */}
          
        </Form>
        <DeleteModal
          visible={visibleDltAvatar}
          closeModal={closeModal}
          selectAvtarId={selectAvtarId}
          updateProfileData={updateProfileData}
        />
        <UploadAvatarModal
          visibleUploadAvatar={visibleUploadAvatar}
          cancelUploadAvatarModal={cancelUploadAvatarModal}
          updateProfileData={updateProfileData}
        />
      </PersonalWrapper>

    </>
  );
};

export default Personal;